import { useEffect } from "react";
import { SITE } from "@/data/site";

const setMeta = (name, content, attr = "name") => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const setJsonLd = (id, data) => {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
};

export const useSeo = ({ title, description, image, path, jsonLd, noindex } = {}) => {
  useEffect(() => {
    const finalTitle = title ? `${title}, ${SITE.brand}` : `${SITE.brand}, ${SITE.tagline}`;
    document.title = finalTitle;
    setMeta("description", description || SITE.short_pitch);
    setMeta("robots", noindex ? "noindex, follow" : "index, follow, max-image-preview:large, max-snippet:-1");
    setMeta("og:title", finalTitle, "property");
    setMeta("og:description", description || SITE.short_pitch, "property");
    setMeta("og:type", "website", "property");
    if (image) {
      const abs = image.startsWith("http") ? image : `https://${SITE.domain}${image}`;
      setMeta("og:image", abs, "property");
      setMeta("twitter:image", abs);
    }
    setMeta("twitter:card", "summary_large_image");
    if (path) {
      const p = path === "/" || path.endsWith("/") ? path : `${path}/`;
      setLink("canonical", `https://${SITE.domain}${p}`);
    }
    if (jsonLd) setJsonLd("ld-page", jsonLd);
  }, [title, description, image, path, jsonLd]);
};
